module.exports = __webpack_public_path__ + "kudos_77.svg?26720b93624bfccc2daa7e62a3e74218";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_77.svg
// module id = 180
// module chunks = 0